import { render, staticRenderFns } from "./explanations.vue?vue&type=template&id=e7cd669c&"
import script from "./explanations.vue?vue&type=script&lang=js&"
export * from "./explanations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports